(function () {
  "use strict";

  var CONTEXT_SELECTOR = "#cpb-product-context";
  var BODY_CLASS = "fmb-standard-monkey-bars-product";
  var INITIALIZED_ATTR = "data-fmb-standard-monkey-bars-ready";

  function isMonkeyBarsProduct() {
    var context = document.querySelector(CONTEXT_SELECTOR);
    if (!context) return false;

    var productType = (context.getAttribute("data-product-type") || "").trim().toLowerCase();
    var isCpb = context.getAttribute("data-is-cpb-product") === "true";

    return productType === "monkey bars" && !isCpb && !document.querySelector("#product-builder");
  }

  function cloneSource(selector) {
    var source = document.querySelector(selector);
    if (!source) return null;

    var clone = source.cloneNode(true);
    clone.removeAttribute("id");
    clone.hidden = false;
    clone.style.removeProperty("display");
    clone.removeAttribute("style");

    return clone;
  }

  function insertAfter(reference, node) {
    if (!reference || !reference.parentNode || !node) return;
    reference.parentNode.insertBefore(node, reference.nextSibling);
  }

  function cleanMoneyText(root) {
    if (!root) return;

    var selectors = [
      ".money",
      ".product__price",
      ".product-single__price",
      "[id^='ProductPrice']",
      ".cpb-recommended-product-price",
      ".cpb-compatible-accessory-price"
    ];

    root.querySelectorAll(selectors.join(",")).forEach(function (el) {
      if (!el || !el.textContent) return;
      el.textContent = el.textContent
        .replace(/\bAUD\b/g, "")
        .replace(/\bA\$/g, "$")
        .replace(/\s+/g, " ")
        .trim();
    });
  }

  function makePanel(title, body, options) {
    if (!body) return null;

    var panel = document.createElement("section");
    panel.className = "fmb-standard-panel";
    if (options && options.className) panel.className += " " + options.className;

    var header = document.createElement("div");
    header.className = "fmb-standard-panel__header";

    if (title) {
      var heading = document.createElement("h3");
      heading.textContent = title;
      header.appendChild(heading);
    } else {
      var sourceHeading = body.querySelector(".cpb-post-action-title");
      if (sourceHeading) header.appendChild(sourceHeading);
    }

    if (options && options.controlsFor) {
      header.appendChild(createTrackControls(options.controlsFor));
    }

    panel.appendChild(header);
    panel.appendChild(body);

    return panel;
  }

  function createTrackControls(track) {
    var controls = document.createElement("div");
    controls.className = "fmb-standard-panel__controls";

    var prev = document.createElement("button");
    prev.className = "fmb-standard-panel__arrow fmb-standard-panel__arrow--prev";
    prev.type = "button";
    prev.setAttribute("aria-label", "Scroll previous");
    prev.textContent = "\u2039";

    var next = document.createElement("button");
    next.className = "fmb-standard-panel__arrow fmb-standard-panel__arrow--next";
    next.type = "button";
    next.setAttribute("aria-label", "Scroll next");
    next.textContent = "\u203a";

    var scrollTrack = function (direction) {
      var amount = Math.max(260, Math.round(track.clientWidth * 0.78));
      track.scrollBy({ left: direction * amount, behavior: "smooth" });
    };

    prev.addEventListener("click", function () { scrollTrack(-1); });
    next.addEventListener("click", function () { scrollTrack(1); });

    controls.appendChild(prev);
    controls.appendChild(next);

    return controls;
  }

  function enhanceIntro(meta) {
    if (!meta || meta.querySelector(".fmb-standard-stat-grid")) return;

    var statsSource = cloneSource("#cpb-metafield-box-source");
    var statsGrid = statsSource && statsSource.querySelector(".product-stat-grid--inline");
    if (statsGrid) {
      statsGrid.classList.add("fmb-standard-stat-grid");
      var price = meta.querySelector(".product__price, .product-single__price, [id^='ProductPrice']");
      var afterpay = meta.querySelector(".afterpay-paragraph, .product__policies, square-placement, [data-mpid]");
      var reference = afterpay || price;

      if (reference && reference.parentNode) {
        insertAfter(reference, statsGrid);
      } else {
        meta.insertBefore(statsGrid, meta.querySelector(".product-single__form") || null);
      }
    }

    var overview = cloneSource("#cpb-seo-summary-source");
    if (overview) {
      overview.classList.add("fmb-standard-overview-card");
      var stats = meta.querySelector(".fmb-standard-stat-grid");
      if (stats) {
        insertAfter(stats, overview);
      } else {
        meta.insertBefore(overview, meta.querySelector(".product-single__form") || null);
      }
    }

    cleanMoneyText(meta);
  }

  function buildGalleryPanel() {
    var source = document.querySelector("#cpb-lifestyle-gallery-source");
    if (!source || !source.children.length) return null;

    var track = document.createElement("div");
    track.className = "fmb-standard-scroll-track fmb-standard-gallery-track";

    Array.prototype.forEach.call(source.children, function (child) {
      if (!child.matches || !child.matches("img, picture")) return;
      var item = document.createElement("div");
      item.className = "fmb-standard-gallery-item";
      item.appendChild(child.cloneNode(true));
      track.appendChild(item);
    });

    if (!track.children.length) return null;

    return makePanel("Gallery", track, {
      className: "fmb-standard-gallery-panel",
      controlsFor: track
    });
  }

  function buildRecommendedPanel() {
    var source = cloneSource("#cpb-recommended-products-source");
    if (!source) return null;

    var track = source.querySelector(".cpb-recommended-products-track");
    if (!track || !track.children.length) return null;

    track.classList.add("fmb-standard-scroll-track");
    cleanMoneyText(source);

    return makePanel(null, source, {
      className: "fmb-standard-shop-setup-panel",
      controlsFor: track
    });
  }

  function buildCompatiblePanel() {
    var source = cloneSource("#cpb-compatible-accessories-source");
    if (!source) return null;

    var track = source.querySelector(".cpb-compatible-accessories-track");
    if (!track || !track.children.length) return null;

    track.classList.add("fmb-standard-scroll-track");
    cleanMoneyText(source);

    var search = source.querySelector(".cpb-compatible-accessories-search");
    if (search) {
      search.addEventListener("input", function () {
        var query = search.value.trim().toLowerCase();
        track.querySelectorAll(".cpb-compatible-accessory-card").forEach(function (card) {
          var text = (card.textContent || "").toLowerCase();
          card.hidden = query && text.indexOf(query) === -1;
        });
      });
    }

    return makePanel(null, source, {
      className: "fmb-standard-compatible-panel",
      controlsFor: track
    });
  }

  function buildSourcePanel(selector, className) {
    var source = cloneSource(selector);
    if (!source) return null;

    return makePanel(null, source, {
      className: className
    });
  }

  function buildPostPanels(productSection) {
    if (!productSection || document.querySelector(".fmb-standard-post-panels")) return;

    var wrapper = document.createElement("div");
    wrapper.className = "fmb-standard-post-panels";

    [
      buildGalleryPanel(),
      buildRecommendedPanel(),
      buildCompatiblePanel(),
      buildSourcePanel("#cpb-feature-cards-source", "fmb-standard-feature-panel"),
      buildSourcePanel("#cpb-key-features-source", "fmb-standard-key-features-panel"),
      buildSourcePanel("#cpb-product-faqs-source", "fmb-standard-faq-panel")
    ].forEach(function (panel) {
      if (panel) wrapper.appendChild(panel);
    });

    if (!wrapper.children.length) return;

    insertAfter(productSection, wrapper);
  }

  function markEnhancementState(productSection) {
    if (!productSection) return;
    productSection.setAttribute(INITIALIZED_ATTR, "true");
    document.body.classList.add(BODY_CLASS);
  }

  function run() {
    if (!isMonkeyBarsProduct()) return;

    var productSection = document.querySelector("#shopify-section-product-template .product-section, .product-section.cpb-basic-product");
    var meta = document.querySelector(".product-single__meta");

    if (!productSection || !meta) return;

    markEnhancementState(productSection);
    enhanceIntro(meta);
    buildPostPanels(productSection.closest(".shopify-section") || productSection);
    cleanMoneyText(document);
  }

  function scheduleRun() {
    window.requestAnimationFrame(run);
  }

  run();
  document.addEventListener("DOMContentLoaded", run, { once: true });
  window.addEventListener("load", run, { once: true });

  setTimeout(run, 250);
  setTimeout(run, 900);
  setTimeout(run, 1800);

  if (window.MutationObserver) {
    new MutationObserver(scheduleRun).observe(document.documentElement, {
      childList: true,
      subtree: true
    });
  }
})();